var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChange = function SvgChange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "26px",
    viewBox: "0 0 31 26",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "changeGroup 12")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LIbraway_loggato",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ricetta_new",
    transform: "translate(-1123.000000, -1161.000000)",
    stroke: "#1D1D1B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1124.000000, 1162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.508086,0.338086957 L2.01071754,0.338086957 C1.08271754,0.338086957 0.330752632,1.10869565 0.329735088,2.05982609 L0.329735088,18.633913 C0.330752632,19.5855652 1.08271754,20.3561739 2.01071754,20.3561739 L5.30196316,20.3561739 C5.4932614,20.3561739 5.64894561,20.5153043 5.64894561,20.712 L5.64894561,23.5283478 C5.64894561,23.8382609 6.00864737,24.0005217 6.2309807,23.7907826 L9.77508596,20.450087 C9.83919123,20.3895652 9.9231386,20.3561739 10.0101386,20.3561739 L26.508086,20.3561739 C27.6268754,20.3561739 28.5340158,19.425913 28.5340158,18.278087 L28.5340158,2.41565217 C28.5340158,1.26834783 27.6268754,0.338086957 26.508086,0.338086957 Z",
    id: "Stroke-1",
    strokeWidth: 1.296
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.4775018,
    y1: 7.86255652,
    x2: 7.38655439,
    y2: 7.86255652,
    id: "Stroke-3",
    strokeWidth: 1.398
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    strokeWidth: 1.398,
    points: "7.38640175 4.86511304 7.38640175 10.3496348 4.11906842 7.86250435"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.38640175,
    y1: 12.8366609,
    x2: 21.4773491,
    y2: 12.8366609,
    id: "Stroke-7",
    strokeWidth: 1.398
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-9",
    strokeWidth: 1.398,
    points: "21.4775018 15.8341043 21.4775018 10.3495826 24.7453439 12.836713"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/change.42113d52.svg";
export { ForwardRef as ReactComponent };